import React from 'react';
import { Route } from '../Routing/types';
import { MealPlanPage } from '@front-activerse/modules';
import descendantRoutes from './descendantRoutes';

const routes: Route[] = [
  {
    path: '/meals/day-plan/*',
    element: <MealPlanPage descendantRoutes={descendantRoutes} />,
    private: true,
    title: 'meals.navbarTitle',
    mobileAppTabIdentifier: 'diet',
    descendantRoutes: descendantRoutes,
  },
];

export default routes;
